<script>

import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../app.config";
import axios from 'axios';
//import DataTable from 'datatables.net-vue3';
import moment from 'moment';
import { TncManagementService } from "../../services/tnc/tnc.service";
import { usePermissions } from '@/composables/usePermissions';

export default {
    page: {
        title: "Program Information",
        meta: [
            {
                name: "description",
                content: appConfig.description,
            },
        ],
    },
    data() {
        return {
            title: "Program Information",
            program_info: [],
            channelpartnerlist:[],
            fincoList:[],
            countryList:[],
            program_name: '',
            program_code: '',
            channel_partner_id: '',
            finco_id: '',
            country_id: '',
            status: '',
            program_type: '',
            tncFilesList: null,
            tnc: null,
            hasHouseDelivery: null,
        };
    },
  setup() {
        const permissions = usePermissions();
        
        return {
            permissions,
        };
    },
    methods: {
        format_date(value){
            if (value) {
                return moment(String(value)).format('DD-MM-YYYY H:m:s')
            }
        },
        get_program_by_id(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'program/edit/'+this.$route.params.id)
            .then(response => {
                if (response) {
                    this.loadingRoles=false;
                    this.program_info = response.data;
                    this.program_name = this.program_info[0].program_name;
                    this.program_code = this.program_info[0].program_code;
                    this.channel_partner_id = this.program_info[0].channel_partner_id;
                    this.finco_id = this.program_info[0].finco_id;
                    this.country_id = this.program_info[0].country_id;
                    this.status = this.program_info[0].status;
                    this.program_type = this.program_info[0].program_type;
                    this.tnc = this.program_info[0].tnc_id;
                    this.hasHouseDelivery = this.program_info[0].has_house_delivery;
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });
        },

        update_program(e)
        {
            this.ButtonSeen=true;
            e.preventDefault()

            const posting_ = { 
                program_name: this.program_name,
                program_code: this.program_code,
                channel_partner_id: this.channel_partner_id,
                finco_id: this.finco_id,
                country_id: this.country_id,
                status: this.status,
                program_type: this.program_type,
                tnc_id: this.tnc,
                has_house_delivery: this.hasHouseDelivery,
            };

            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.post(process.env.VUE_APP_API_BASEURL+'program/update/'+this.$route.params.id, posting_)
            .then(response => {
                if (response) {
                  this.ButtonSeen=false; 
                  alert(response.data.msj); 
                  this.$router.push({ name: 'program' });                      
                }
                else{
                    this.ButtonSeen=false;
                }
            });
        },

        //raw data----------------------------------------------------------

        get_channel_partner(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'channelpartner/raw_data')
            .then(response => {
                if (response) {
                    this.loadingRoles=false;
                    this.channelpartnerlist = response.data;
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });
        },

        get_finco(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'finco/raw_data')
            .then(response => {
                if (response) {
                    this.loadingRoles=false;
                    this.fincoList = response.data;
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });
        },

        get_country(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'finco/raw_data_country')
            .then(response => {
                if (response) {
                    this.loadingRoles=false;
                    this.countryList = response.data;
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });
        },

        async get_tncs() {
          const response = await TncManagementService.getTnc();
          this.tncFilesList = response.data;
        }

        //raw data----------------------------------------------------------
    },

    components: {
        Layout,
        PageHeader, 
    },

    mounted() {     
        this.get_program_by_id();   
        this.get_channel_partner();
        this.get_finco();
        this.get_country();
        this.get_tncs();
    },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-header">
            <div class="d-flex align-items-center">
              <h4><span class="badge badge-soft-primary badge-border">Program : {{ program_name }}</span></h4>
            </div>
          </div>
          <div class="card-body">
            <div class="live-preview">
              <form @submit="update_program">
                <div class="row mb-3">
                  <div class="col-lg-3">
                    <label for="program_name" class="form-label">Program Name *</label>
                  </div>
                  <div class="col-lg-7">
                    <input v-model='program_name' type="text" class="form-control" id="program_name" required />
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-lg-3">
                    <label for="program_code" class="form-label">Program Code *</label>
                  </div>
                  <div class="col-lg-7">
                    <input v-model='program_code' type="text" class="form-control" id="program_code" required />
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-lg-3">
                    <label for="channel_partner_id" class="form-label">Channel Partner *</label>
                  </div>
                  <div class="col-lg-7">
                    <select v-model="channel_partner_id" class="form-select mb-3" arial-label="Default select example"
                      placeholder="Please Select" required>
                      <option value="">--- Select Channel Partner ---</option>
                      <option v-for="(item, index) in channelpartnerlist" :key="index" :value="item.id">
                        {{ item.name }}
                      </option>
                    </select>
                  </div>
                  <div class="col-lg-3">
                    <label for="finco_id" class="form-label">Finco *</label>
                  </div>
                  <div class="col-lg-7">
                    <select v-model="finco_id" class="form-select mb-3" arial-label="Default select example"
                      placeholder="Please Select" required>
                      <option value="">--- Select Finco ---</option>
                      <option v-for="(item, index) in fincoList" :key="index" :value="item.id">
                        {{ item.name }}
                      </option>
                    </select>
                  </div>
                  <div class="col-lg-3">
                    <label for="country_id" class="form-label">Country *</label>
                  </div>
                  <div class="col-lg-7">
                    <select v-model="country_id" class="form-select mb-3" arial-label="Default select example"
                      placeholder="Please Select" required>
                      <option value="">--- Select Country ---</option>
                      <option v-for="(item, index) in countryList" :key="index" :value="item.id">
                        {{ item.name }}
                      </option>
                    </select>
                  </div>
                  <div class="col-lg-3">
                    <label for="country_id" class="form-label">Program Type *</label>
                  </div>
                  <div class="col-lg-7 mb-3">
                    <select v-model="program_type" class="form-select mb-0" arial-label="Default select example"
                      required>
                      <option value="ONLINE">ONLINE</option>
                      <option value="OFFLINE">OFFLINE</option>
                    </select>
                  </div>
                  <div class="col-lg-3">
                    <label for="country_id" class="form-label">TNC</label>
                  </div>
                  <div class="col-lg-7">
                    <select v-model="tnc" class="form-select mb-3" arial-label="Default select example"
                      placeholder="Please Select" required>
                      <option value="">--- Select TNC ---</option>
                      <option v-for="(item, index) in tncFilesList" :key="index" :value="item.id">
                        {{ item.title }}
                      </option>
                    </select>
                  </div>
                  <div class="row mb-3">
                    <div class="col-lg-3">
                      <label for="house_delivery" class="form-label">House Delivery</label>
                    </div>
                    <div class="col-lg-7">
                      <div class="list-group list-group-horizontal border-0">
                        <label class="list-group-item border me-2">
                          <input class="form-check-input fs-14 mt-0 align-middle me-1" name="hasHouseDelivery"
                            v-model="hasHouseDelivery" type="radio" value="1" />
                          Enable
                        </label>
                        <label class="list-group-item border">
                          <input class="form-check-input fs-14 mt-0 align-middle me-1" name="hasHouseDelivery"
                            v-model="hasHouseDelivery" type="radio" value="0" />
                          Disable
                        </label>
                      </div>
                    </div>
                  </div>

                  <div class="row mb-3">
                    <div class="col-lg-3">
                      <label for="status" class="form-label">Status</label>
                    </div>
                    <div class="col-lg-7">
                      <div class="list-group list-group-horizontal border-0">
                        <label class="list-group-item border me-2">
                          <input class="form-check-input fs-14 mt-0 align-middle me-1" name="status" v-model="status"
                            type="radio" value="1" />
                          Enable
                        </label>
                        <label class="list-group-item border">
                          <input class="form-check-input fs-14 mt-0 align-middle me-1" name="status" v-model="status"
                            type="radio" value="0" />
                          Disable
                        </label>
                      </div>
                    </div>
                  </div>

                </div>

                <hr class="my-4 text-muted">
                <div class="text-end col-lg-5">
                  <a @click="$router.go(-1)" class="btn btn-success">Back</a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <button v-if="permissions.canCreate?.value" type="submit" class="btn btn-primary">
                    Update
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
